import { VehicleAttributeCategoryService } from "./../../vehicle-attribute-category/models/vehicleattributecategory.service";
import { IKeyValueInterface, RoleLevel } from "./../../shared/config";
import { TranslateService } from "./../../shared/translate/translate.service";
import { AuthService } from "./../../shared/models/auth.service";
import { InstanceService } from "./../../instance/models/instance.service";
import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { VehicleAttributeModel } from "../models/vehicleattribute.model";
import { VehicleAttributeService } from "../models/vehicleattribute.service";
import { Router, ActivatedRoute } from "@angular/router";
import { DropdownModel } from "../../report/models/report-filter.model";
import {
  WeGoConfig,
  IAPIResponse,
  ApplicationRouteURL,
  PermissionType
} from "../../shared/config";
import { Location } from "@angular/common";

@Component({
  selector: "wego-vehicleattribute-list",
  template: require('../views/vehicleattribute-update.component.html'),
  providers: [
    VehicleAttributeCategoryService,
    VehicleAttributeService,
    InstanceService
  ]
})
export class VehicleAttributeUpdateComponent implements OnInit, OnDestroy {
  vehicleAttributeHashId: string;
  sub: any;
  submitted = false;
  model: VehicleAttributeModel;
  vehicleAttributeCategoryList: any;
  instanceList: DropdownModel[];
  apiResponse: IAPIResponse;
  errorModel: IKeyValueInterface[];
  errorMessage: string;
  message: string;
  isEditMode: boolean;
  urlDefaultPage: string;
  urlVehicleAttributeList: string;
  instanceHashId: string;
  pageName: string;
  accessDeniedErrorCode : string;
  roleLevel = RoleLevel;
  
  private popupMsg: string;
  private module: string;
  private breadCrumbTitle: string;
  private breadCrumbList: string;


  @ViewChild("alertModal") public alertModal: any;
  @ViewChild("successPopup") public successPopup: any;

  constructor(
    private vehicleAttributeService: VehicleAttributeService,
    private vehicleAttributeCategoryService: VehicleAttributeCategoryService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private translate: TranslateService,
    private instanceService: InstanceService,
    private locationService: Location
  ) { }

  ngOnInit() {
    this.accessDeniedErrorCode = "412";
    this.pageName = "Vehicle_Attribute";
    this.module = this.translate.instant("LblVehicleAttributes");
    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
    this.urlVehicleAttributeList = this.authService.GetURL(
      ApplicationRouteURL.URL_VEHICLEATTRIBUTE_LIST
    );
    this.model = new VehicleAttributeModel();

    this.sub = this.activeRoute.params.subscribe(params => {
      let categryAttributeHashId = params["id"] || "";
      if (categryAttributeHashId != "") {
        this.GetInstanceListDropdown(PermissionType.EDIT);
      }
      else {
        this.GetInstanceListDropdown(PermissionType.INSERT);
      }
    });
  }

  public GetVehicleAttributeDetails() {
    this.sub = this.activeRoute.params.subscribe(params => {
      this.vehicleAttributeHashId = params["id"] || "";
      if (this.vehicleAttributeHashId != "") {
        this.isEditMode = true;
        this.vehicleAttributeService
          .GetVehicleAttributeByHashId(this.vehicleAttributeHashId)
          .subscribe(
          res => (this.model = res.data),
          error => {
            this.errorMessage = this.authService.HandleErrorStatusCode(error);
          },
          () => {
            this.GetVehicleAttributeCategoryListByInstance(
              this.model.instanceHashId,
              this.model.vehicleAttributeCategoryHashId
            );
          }
          );
      } else {
        this.isEditMode = false;
      }
    });
    this.breadCrumbTitle = this.isEditMode
      ? this.translate.instant("LblEditPage", [this.module])
      : this.translate.instant("LblAddPage", [this.module]);
    this.breadCrumbList = this.translate.instant("LblListPage", [this.module]);
  }
  public GetVehicleAttributeCategoryList() {
    this.vehicleAttributeCategoryService
      .GetVehicleAttributeCategoryList()
      .subscribe(
      (res: any) => {
        this.apiResponse = res;
        this.vehicleAttributeCategoryList = res.data;
        // this.model.vehicleAttributeCategoryHashId = this.model.vehicleAttributeCategoryHashId || this.vehicleAttributeCategoryList[0].vehicleAttributeCategoryHashId;
      },
      (error: any) => {
        this.errorMessage = <any>error;
      },
      () => this.GetVehicleAttributeDetails()
      );
  }
  public GetVehicleAttributeCategoryListByInstance(
    instanceHashId: string,
    vehicleAttributeCategoryHashId?: string
  ) {
    this.vehicleAttributeCategoryService
      .GetVehicleAttributeCategoryByInstance(instanceHashId)
      .subscribe(
      (res: any) => {
        this.apiResponse = res;
        this.vehicleAttributeCategoryList = res.data;
      },
      (error: any) => {
        this.errorMessage = <any>error;
      }
      );
  }
  onSubmit(forms: any) {
    this.submitted = true;
    this.AddNewVehicleAttribute(JSON.stringify(this.model));
  }

  public AddNewVehicleAttribute(formData: any) {
    this.vehicleAttributeService.AddNewVehicleAttribute(formData).subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.isEditMode
            ? this.translate.instant("LblRecordUpdatedSuccess", [this.module])
            : this.translate.instant("LblRecordAddedSuccess", [this.module]);
          this.ShowSuccessPopup();
        } else {
          this.errorModel = res.error;
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
      }
    );
  }
  public GetInstanceListDropdown(permissionType: string) {
    this.instanceService.GetInstanceListDropdownForAddUpdatePage(this.pageName, permissionType).subscribe(
      res => {
        this.apiResponse = res;
        this.instanceList = res.data;
        if (this.instanceList.length == 0){
          this.authService.HandleErrorStatusCode(this.accessDeniedErrorCode);
        }

        if (this.instanceList && this.instanceList.length > 0) {
          if (!this.model.instanceHashId && this.instanceList.length == 1) {
            this.model.instanceHashId = this.instanceList[0].keyHash;
            this.onChangeSelectedInstance(this.model.instanceHashId);
          }
          //this.onChangeSelectedInstance(this.model.instanceHashId);
        }
      },
      error => {
        this.errorMessage = <any>error;
      },
      () => this.GetVehicleAttributeDetails()
    );
  }
  public onChangeSelectedInstance(instanceHashId: string) {
    this.vehicleAttributeCategoryList = [];
    this.model.vehicleAttributeCategoryHashId = "";
    this.GetVehicleAttributeCategoryListByInstance(instanceHashId);
  }
  public ShowAlertModal(): void {
    this.alertModal.show();
  }

  public HideAlertModal(): void {
    this.alertModal.hide();
  }
  public onChangeSelectedField(value: any): void {
    this.model.vehicleAttributeCategoryHashId = value;
  }

  public SuccessAlertModalClick(): void {
    this.alertModal.hide();
    this.router.navigate([this.urlVehicleAttributeList]);
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public OnBackClick() {
    this.locationService.back();
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/vehicle-attribute/components/vehicleattribute-update.component.ts